/* less/lib/less/render */ function _(require, module, exports) {
    var PromiseConstructor, utils = require(245) /* ./utils */;
    module.exports = function (environment, ParseTree, ImportManager) {
        var render = function (input, options, callback) {
            if (typeof options === 'function') {
                callback = options;
                options = utils.copyOptions(this.options, {});
            }
            else {
                options = utils.copyOptions(this.options, options || {});
            }
            if (!callback) {
                if (!PromiseConstructor) {
                    PromiseConstructor = typeof Promise === 'undefined' ? require(277) /* promise */ : Promise;
                }
                var self = this;
                return new PromiseConstructor(function (resolve, reject) {
                    render.call(self, input, options, function (err, output) {
                        if (err) {
                            reject(err);
                        }
                        else {
                            resolve(output);
                        }
                    });
                });
            }
            else {
                this.parse(input, options, function (err, root, imports, options) {
                    if (err) {
                        return callback(err);
                    }
                    var result;
                    try {
                        var parseTree = new ParseTree(root, imports);
                        result = parseTree.toCSS(options);
                    }
                    catch (err) {
                        return callback(err);
                    }
                    callback(null, result);
                });
            }
        };
        return render;
    };
}
